import poi from './poi';
import brand from './brand';

export default {
  poi,
  brand,
};
